import { Button, Panel } from "@gokkehub/ui";
import { useAuth } from "@/context/AuthContext";

export default function LoginPage() {
  const { loginWithDiscord } = useAuth();

  return (
    <div className="pwa-safe-top min-h-screen flex flex-col items-center justify-center p-5"
      style={{ background: "var(--bg-tint-1)" }}>
      <div className="w-full max-w-sm">
        <div className="text-center mb-6">
          <h1 className="font-display text-3xl font-bold" style={{ color: "rgb(var(--text-primary-rgb))" }}>
            Gokke<span style={{ color: "rgb(var(--color-primary-rgb))" }}>Poker</span>
          </h1>
          <p className="text-sm mt-1" style={{ color: "rgb(var(--text-muted-rgb))" }}>
            The house always tracks.
          </p>
        </div>

        <Panel>
          <p className="font-semibold text-center mb-5" style={{ color: "rgb(var(--text-primary-rgb))" }}>
            Sign in with your GokkeHub Discord
          </p>
          <Button fullWidth onClick={loginWithDiscord}>
            <span className="flex items-center justify-center gap-2 w-full">
              <DiscordIcon />
              Continue with Discord
            </span>
          </Button>
          <p className="text-center text-xs mt-4" style={{ color: "rgb(var(--text-muted-rgb))" }}>
            Same account as the rest of GokkeHub. Your profile is created automatically the first time.
          </p>
        </Panel>
      </div>
    </div>
  );
}

function DiscordIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden>
      <path d="M20.317 4.37a19.791 19.791 0 0 0-4.885-1.515.074.074 0 0 0-.079.037c-.21.375-.444.864-.608 1.25a18.27 18.27 0 0 0-5.487 0 12.64 12.64 0 0 0-.617-1.25.077.077 0 0 0-.079-.037A19.736 19.736 0 0 0 3.677 4.37a.07.07 0 0 0-.032.027C.533 9.046-.32 13.58.099 18.057c.002.022.015.043.033.055a19.89 19.89 0 0 0 5.993 3.03.078.078 0 0 0 .084-.028 14.09 14.09 0 0 0 1.226-1.994.076.076 0 0 0-.041-.106 13.107 13.107 0 0 1-1.872-.892.077.077 0 0 1-.008-.128 10.2 10.2 0 0 0 .372-.292.074.074 0 0 1 .077-.01c3.928 1.793 8.18 1.793 12.062 0a.074.074 0 0 1 .078.01c.12.098.246.198.373.292a.077.077 0 0 1-.006.127 12.299 12.299 0 0 1-1.873.892.077.077 0 0 0-.041.107c.36.698.772 1.362 1.225 1.993a.076.076 0 0 0 .084.028 19.839 19.839 0 0 0 6.002-3.03.077.077 0 0 0 .032-.054c.5-5.177-.838-9.674-3.549-13.66a.061.061 0 0 0-.031-.03zM8.02 15.331c-1.182 0-2.157-1.085-2.157-2.419 0-1.333.956-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.956 2.418-2.157 2.418zm7.975 0c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.955-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.946 2.418-2.157 2.418z" />
    </svg>
  );
}
